<template>
    <v-dialog
        v-model="withoutTrailersDlg"
        width="500px"
    >
        <v-card>
            <v-toolbar color="secondary" dense dark>
                <v-toolbar-title>
                    Shifts without Trailer
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon @click="$emit('close')"><v-icon>mdi-close</v-icon></v-btn>
            </v-toolbar>
            <v-container grid-list-xs fluid>
                <v-data-table
                    :headers="headers"
                    :items="withoutTrailers"
                    dense
                ></v-data-table>
            </v-container>
        </v-card>
    </v-dialog>
</template>
<script>
export default{
    props:['withoutTrailers','withoutTrailersDlg'],
    data:function () {
        return{
            wind:0,
            trailers:[],
            headers:[
            {text:"ShiftDetail", value:"ShiftDetail"},
                {text:"Driver", value:"Driver"},
            ],
        }
    },
}
</script>